import { ScanSearchIcon, SearchIcon } from 'lucide-react'
import { useEffect, useState } from 'react'

import {
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components'
import {
  type DocumentsSearchBlock,
  useSearchDocuments,
} from '@/modules/documents'
import { useFolders } from '@/modules/folders'
import { SearchPagePreview } from './SearchPagePreview'
import { SearchResults } from './SearchResults'

export const SearchView = () => {
  const folders = useFolders()
  const [selectedResult, setSelectedResult] =
    useState<DocumentsSearchBlock | null>(null)
  const { results, query, setQuery, folderSlug, setFolderSlug } =
    useSearchDocuments()

  useEffect(() => {
    setSelectedResult(results[0] || null)
  }, [results])

  return (
    <div className="grid grid-cols-2 gap-4 h-[calc(100vh-150px)]">
      <div className="flex flex-col min-h-0">
        <div className="flex gap-2 rounded-t-lg border border-b-0 px-3 py-2">
          <Select
            value={folderSlug === null ? 'all' : String(folderSlug)}
            onValueChange={setFolderSlug}
          >
            <SelectTrigger className="w-52">
              <SelectValue placeholder="Select folder" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Root documents</SelectItem>
              {folders.map((folder) => (
                <SelectItem key={folder.slug} value={String(folder.slug)}>
                  {folder.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <div className="relative flex-1">
            <SearchIcon className="absolute left-2.5 top-1/2 -translate-y-1/2 size-4 text-muted-foreground pointer-events-none" />
            <Input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search documents..."
              className="pl-8"
            />
          </div>
        </div>

        <SearchResults
          results={results}
          selectedResult={selectedResult}
          onSelect={setSelectedResult}
          query={query}
        />
      </div>

      <div className="min-h-0">
        {selectedResult ? (
          <SearchPagePreview
            blockRef={selectedResult.blockRef}
            documentId={selectedResult.documentId}
            pageNumber={selectedResult.pageNumber}
          />
        ) : (
          <div className="flex flex-col items-center justify-center gap-2 rounded-lg border text-muted-foreground h-full bg-barberpole-accent">
            <ScanSearchIcon className="size-8" />
            <p className="text-xl">Select a result to preview</p>
          </div>
        )}
      </div>
    </div>
  )
}
